export default {
  stopPropagation: (e: React.SyntheticEvent): void => {
    e.stopPropagation();
  },
};
